module.exports = __webpack_public_path__ + "img/corporateCulture3.0b89a12f.png";